import { IRequestStatusBadge } from "../utils/types";

const RequestStatusBadge =(props:any)=>{
    const item:IRequestStatusBadge = props.status
    return (<span className={`flex items-center space-x-2 w-full ${props.className}`}><item.icon className={item.color}/><span className={`${item.color}`}>{item.text}</span></span>)
}
export default RequestStatusBadge